import { FC } from 'react';
import Color from 'color-js';
import { useConfig } from '../../hooks/config';
import { lineheights, sizes, weights, fontFamilyModifiers } from './config';

interface iLineProps {
  i: number;
  margin: number;
  support: string;
  value: any;
  content: any[];
  isOn: boolean;
  sizeModified: number;
  weight: string;
  scale: number;
}
const Line: FC<iLineProps> = ({ i, margin, scale, value, content, isOn, sizeModified, weight }) => {
  const config = useConfig();
  return (
    <div
      className='line'
      style={{
        marginTop: i !== 0 ? margin : undefined,
        marginBottom: i !== value.length - 1 ? margin : undefined,
      }}
    >
      {content.map((line: any, index: number) => {
        const baseColor = Color(line.color ?? config.options.colors[0].color);
        const color = baseColor.lightenByAmount(0.05);

        let fontFamily = line.family ?? config.options.families?.[0]?.family;
        const fontSizeModifier = fontFamilyModifiers[fontFamily] ?? 1;
        const size = line.size;
        const fontSize = sizes[size ?? 'M'] * sizeModified * fontSizeModifier;

        const lineHeight = lineheights[line.lineheight ?? 'M'];

        const shadow = `
          0 0 56px ${baseColor.lightenByAmount(0.2).toRGB()},
          0 0 48px ${baseColor.lightenByAmount(0.1).toRGB()},
          0 0 32px ${baseColor.lightenByAmount(0.05).toRGB()},
          0 0 80px #fff,
          0 0 150px #fff, 
          0 0 4px #fff
        `.replace('\n', '');

        const fontWeight: any = weights[weight];
        const width = line.text?.length === 0 ? 12 : undefined;

        if (fontFamily?.includes('ttf')) {
          const family = config.options.families.find((_) => _.family === fontFamily);
          fontFamily = family?.name;
        }

        if (!fontFamily) fontFamily = config.options.families[0]?.name;

        return (
          <div className='segment' key={`line-${i}-content-${index}`} style={{ width }}>
            <span
              style={{
                fontFamily,
                lineHeight,
                fontWeight,
                fontSize,
                color: isOn ? color.toRGB() : 'white',
                width,
              }}
              className='main'
            >
              {line.text}
            </span>
            {isOn && (
              <span
                style={{ fontFamily, lineHeight, fontWeight, fontSize, textShadow: shadow, width }}
                className='shadow'
              >
                {line.text}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Line;
